export default "__VITE_ASSET__BS59Jzu0__"